import { cloneDeep } from 'lodash'
import create, { SetState, StateCreator, StoreApi } from 'zustand'

interface PatientProfileMatrixStore {
    patientProfileMatrixData : any,
    setPatientProfileMatrixData : (x:any) => void
    clearStore: () => void
}

let  store: StateCreator<PatientProfileMatrixStore, [], [], PatientProfileMatrixStore> | StoreApi<PatientProfileMatrixStore> = (set: SetState<PatientProfileMatrixStore>) => ({
    patientProfileMatrixData: null,
    setPatientProfileMatrixData: (x) => {
        set(state => ({ patientProfileMatrixData : cloneDeep(x) }))
    },
    clearStore: () => {
        set(() => ({patientProfileMatrixData:  null, dataCardId: null}))
    }
})


export const usePatientProfileMatrixStore  = create(store)